import React, { useState } from 'react';
import { IconClose } from '../utils/icons';

export function FilesModal({ payment, onClose, onUploadInvoices, onUploadProof, userRole }) {
  const roleLc = (userRole ?? '').toString().toLowerCase();
  const isAdmin = roleLc === 'admin';
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [proofFile, setProofFile] = useState(null);

  if (!payment) return null;

  const invoices = payment.attachments || [];
  const hasProof = !!payment.proof_file_path;

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" />
      <div className="relative w-full max-w-2xl overflow-hidden rounded-2xl border border-white/10 bg-white shadow-2xl" onClick={(e)=>e.stopPropagation()}>
        <div className="flex items-center justify-between bg-gradient-to-r from-slate-900 to-slate-700 px-5 py-3">
          <h3 className="text-white font-semibold">Archivos de “{payment.title}”</h3>
          <button onClick={onClose} className="text-white/80 hover:text-white"><IconClose/></button>
        </div>

        <div className="p-5 space-y-6">
          {/* Facturas */}
          <section>
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-semibold text-slate-800">Facturas</h4>
              <span className="text-xs text-slate-500">{invoices.length} archivo(s)</span>
            </div>
            {invoices.length === 0 ? (
              <p className="text-sm text-slate-500">No hay facturas adjuntas.</p>
            ) : (
              <ul className="divide-y divide-slate-100 rounded-xl border border-slate-200/70 bg-white max-h-64 overflow-y-auto">
                {invoices.map((a) => (
                  <li key={a.id} className="flex items-center justify-between px-3 py-2">
                    <div className="min-w-0">
                      <div className="truncate text-sm font-medium text-slate-800">{a.file_name}</div>
                      <div className="text-xs text-slate-500">/uploads/{a.file_path}</div>
                    </div>
                    <a
                      href={`/uploads/${(a.file_path || '').replace(/#/g, '%23')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-lg bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-200"
                    >
                      Abrir
                    </a>
                  </li>
                ))}
              </ul>
            )}

            {isAdmin && (
              <div className="mt-3">
                <label className="text-xs font-medium text-slate-600">Agregar facturas</label>
                <input
                  type="file"
                  multiple
                  accept="application/pdf,image/*"
                  onChange={(e)=> setInvoiceFiles(Array.from(e.target.files||[]))}
                  className="mt-1 block w-full rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"
                />
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-xs text-slate-500">Seleccionadas: <b>{invoiceFiles.length}</b></span>
                  <button
                    disabled={!invoiceFiles.length}
                    onClick={async ()=>{
                      await onUploadInvoices(payment.id, invoiceFiles);
                      setInvoiceFiles([]);
                    }}
                    className="rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-40"
                  >
                    Subir
                  </button>
                </div>
              </div>
            )}
          </section>

          {/* Comprobante */}
          <section>
            <h4 className="text-sm font-semibold text-slate-800 mb-2">Comprobante de pago</h4>
            {hasProof ? (
              <div className="flex items-center justify-between rounded-xl border border-slate-200/70 bg-slate-50 px-3 py-2">
                <div className="min-w-0">
                  <div className="truncate text-sm font-medium text-slate-800">comprobante.pdf</div>
                  <div className="text-xs text-slate-500">/uploads/{payment.proof_file_path}</div>
                </div>
                <a
                  href={`/uploads/${(payment.proof_file_path || '').replace(/#/g, '%23')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-lg bg-slate-100 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-200"
                >
                  Abrir
                </a>
              </div>
            ) : (
              <p className="text-sm text-slate-500">Aún no se ha cargado el comprobante.</p>
            )}

            {isAdmin && payment.status === 'pagado' && (
              <div className="mt-3">
                <label className="text-xs font-medium text-slate-600">Subir/actualizar comprobante (PDF)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e)=> setProofFile((e.target.files||[])[0] || null)}
                  className="mt-1 block w-full rounded-xl border-slate-200 focus:ring-2 focus:ring-slate-900/20"
                />
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-xs text-slate-500">{proofFile ? proofFile.name : 'Sin archivo seleccionado'}</span>
                  <button
                    disabled={!proofFile}
                    onClick={async ()=>{
                      await onUploadProof(payment.id, proofFile);
                      setProofFile(null);
                    }}
                    className="rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-40"
                  >
                    Subir comprobante
                  </button>
                </div>
              </div>
            )}
          </section>
        </div>

        <div className="border-t bg-slate-50 px-5 py-3 flex justify-end">
          <button onClick={onClose} className="rounded-xl bg-white border border-slate-200 px-4 py-2 text-slate-700 hover:bg-slate-50">Cerrar</button>
        </div>
      </div>
    </div>
  );
}
